"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderInitialInvoiceSchema = void 0;
const boomi_order_default_1 = require("./boomi-order-default");
const EVENT_INFO_DEFINITION = {
    properties: {
        autoRenewStatus: {
            type: 'boolean'
        },
        isTrial: {
            type: 'boolean'
        },
        isIntroOfferPeriod: {
            type: 'boolean'
        },
        expiresDate: {
            type: 'string',
            minLength: 10
        },
    },
    required: [
        'autoRenewStatus',
        'isTrial',
        'isIntroOfferPeriod',
        'expiresDate'
    ],
    type: 'object'
};
const EVENT_INFO_PROPERTY = {
    $ref: '#/definitions/EventInfo'
};
const EVENT_TYPE_DEFINITION = {
    enum: [
        'INITIAL_INVOICE',
    ],
    type: 'string'
};
const EVENT_TYPE_PROPERTY = {
    $ref: '#/definitions/EventType'
};
exports.BoomiOrderInitialInvoiceSchema = {
    ...boomi_order_default_1.BoomiOrderDefaultSchema,
    definitions: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.definitions,
        EventInfo: EVENT_INFO_DEFINITION,
        EventType: EVENT_TYPE_DEFINITION,
    },
    properties: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.properties,
        eventInfo: EVENT_INFO_PROPERTY,
        eventType: EVENT_TYPE_PROPERTY,
    }
};
//# sourceMappingURL=data:application/json;base64,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